import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import LogDetailDialog from "../syslogs/LogDetailDialog";
import { getLogsColumns } from "../syslogs/getLogsColumns";
import SystemLogService from "../syslogs/SystemLogService";

export default function BrTabLog({ bedrockIdeaId, onError }) {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 15 });
    const [totalRows, setTotalRows] = useState(0);
    const [selectedLog, setSelectedLog] = useState(null);
    const [detailDialogOpen, setDetailDialogOpen] = useState(false);

    useEffect(() => {
        if (!bedrockIdeaId) return;
        let cancelled = false;
        const fetchLogs = async () => {
            setLoading(true);
            const result = await SystemLogService.list(
                paginationModel.page,
                paginationModel.pageSize,
                "createdAt:desc",
                null,
                null,
                null,
                bedrockIdeaId
            );
            setLoading(false);
            if (cancelled) return;
            if (result.success && result.data) {
                const data = result.data;
                setLogs(data.content || []);
                setTotalRows(data.page?.totalElements ?? 0);
            } else if (onError) {
                onError("error", result.error || "Failed to fetch logs");
            }
        };
        fetchLogs();
        return () => { cancelled = true; };
    }, [bedrockIdeaId, paginationModel.page, paginationModel.pageSize]);

    const handleRowClick = (params) => {
        setSelectedLog(params.row);
        setDetailDialogOpen(true);
    };

    if (!bedrockIdeaId) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <DataGrid
                rows={logs}
                columns={getLogsColumns()}
                getRowId={(row) => row.id}
                loading={loading}
                paginationMode="server"
                rowCount={totalRows}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[15, 25, 50]}
                disableRowSelectionOnClick
                onRowClick={handleRowClick}
                autoHeight
                sx={{ minHeight: 400, "& .MuiDataGrid-row": { cursor: "pointer" } }}
            />

            <LogDetailDialog
                open={detailDialogOpen}
                onClose={() => {
                    setDetailDialogOpen(false);
                    setSelectedLog(null);
                }}
                log={selectedLog}
            />
        </Box>
    );
}
